import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { BusinessDisplay } from './BusinessDisplay';

export const BusinessDisplayBridge = react2angular(BusinessDisplay, [
  'data',
  'visibility'
]);
